const Divider = () => (
  <hr className="w-12 h-[6px] mx-auto my-4 bg-brand-primary100 border-0 md:my-10" />
);

export { Divider };
